import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable, of } from "rxjs";
import { UtilityService } from "services/utility.service";
import { Router, NavigationStart, ActivatedRoute } from "@angular/router";
import { filter } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class LogsService {
  private dataSubject = new BehaviorSubject<any>(null); // Holds the latest value
  private dataObservable$ = this.dataSubject.asObservable(); // Exposed observable

  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute
  ) {}
  setData(data: any): void {
    this.dataSubject.next(data);
  }
  // Get data
  getData(): Observable<any> {
    return this.dataObservable$;
  }
}
